/* === CLAUDE-SHOPIFY-CHANGE-020-START | Judge.me "*Türkçeye çevrilmiştir*" notunu küçük etikete çevirir — sadece görünüm (2026-09-30) === */
(function () {
  var RX = /\s*\*\s*T[üu]rk[çc]eye [çc]evrilmi[şs]tir\s*\*\s*$/i;

  function tag() {
    var ps = document.querySelectorAll('#judgeme_product_reviews .jdgm-review-content__body-content p');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.querySelector('.wl-rev-translated')) continue;
      var last = p.lastChild;
      while (last && last.nodeType === 3 && !last.textContent.trim()) last = last.previousSibling;
      if (!last || last.nodeType !== 3 || !RX.test(last.textContent)) continue;
      last.textContent = last.textContent.replace(RX, '');
      var span = document.createElement('span');
      span.className = 'wl-rev-translated';
      span.textContent = 'Türkçeye çevrildi';
      p.appendChild(span);
    }
  }

  function boot() {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; tag(); }, 60);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    tag();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* === CLAUDE-SHOPIFY-CHANGE-020-END === */
